module.exports = __webpack_public_path__ + "media/images/farmgirl-7f1076f45bfde2b950632f204486ba60.png";